import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  illustration: ({ spacing, grid }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${spacing.md} auto;

    @media (max-width: ${grid.breakpoint.sm}) {
      max-width: 175px;
    }
  `,

  wrapperText: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,

  wrapperCaption: ({ spacing, grid }) => css`
    margin: ${spacing.xs} 0 ${spacing.md} 0;
    @media (max-width: ${grid.breakpoint.sm}) {
      margin-bottom: ${spacing.xs};
    }
  `,
})

export { useStyles }
